import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, theme } from "antd";
import { observer } from "mobx-react";
import { COLOR_PRIMARY_SOFT_BG } from "../../../../../style/antdTheme.js";
const ProductLogo = observer(({ subscription })=>{
    const { token } = theme.useToken();
    const { productPlan: { product: { name, logoSquare } } } = subscription.data;
    const inactiveStyle = subscription.isCancelled ? {
        filter: "grayscale(1)",
        opacity: 0.55
    } : undefined;
    if (logoSquare?.downloadUrl) {
        return /*#__PURE__*/ _jsx(Avatar, {
            shape: "square",
            src: logoSquare.downloadUrl,
            size: 48,
            style: {
                borderRadius: 8,
                ...inactiveStyle
            }
        });
    }
    return /*#__PURE__*/ _jsx(Avatar, {
        shape: "square",
        size: 48,
        style: {
            borderRadius: 8,
            background: COLOR_PRIMARY_SOFT_BG,
            color: token.colorPrimary,
            fontWeight: 600,
            fontSize: 20,
            ...inactiveStyle
        },
        children: name.charAt(0).toUpperCase()
    });
});
export { ProductLogo };
